/* eslint-disable no-console */
import {httpPost} from './http.service';

export const generateAnswers = (request: {question: string; numberOfAnswers: number}): Promise<string[]> => {
    return httpPost(`editor/languageModel/answers`, request).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const generateText = (request: {prompt: {text: string; prompt: string}; temperature?: number}): Promise<string[]> => {
    return httpPost(`editor/languageModel/text`, request).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};
